import React from "react";
import { CareerListModel } from "../../../domain/entities/CareerListModel";
import CareerItem from "./CareerItem";

interface CareerListProps {
    careers: CareerListModel
}

const CareerList : React.FC<CareerListProps> = ({careers}) => {
    return (
        <div className="flex flex-col justify-center items-center md:flex-col gap-2 md:gap-4 md:px-4 mx-4 md:mx-48 md:mb-12 mb-9">
            {/* Map through careers with centered alignment */}
            {careers.careers.map((career) => (
                <div 
                    key={career.id} 
                    className="w-full md:w-3/6 mx-auto flex-shrink-0"
                >
                    <CareerItem 
                        career={career} 
                    />
                </div>
            ))}
        </div>
    );
}

export default CareerList;